var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex justify-center align-center",attrs:{"id":"dashboard","fluid":"","tag":"section"}},[_c('h1',{staticClass:"blue--text"},[_vm._v("Bem Vindo ao CMS!!!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }